/**
 * LMS list filter state.
 *
 * Agreement-date range, DPD bucket, due-instalment count and executive
 * type/name used to live here too. /lms_loan/get_loan_list/ accepts none of
 * those as query params, so the controls bound to them filtered nothing —
 * they had already been commented out of the template and only the state
 * remained. Removed with the controls; re-adding one means adding the backend
 * parameter first.
 */
const initialState = () => ({
  page: 1,
  lead_status: "Applied Loan",
  selected_tab: 0,
  scheme: [], // multi-select
  city: [], // multi-select
  selected_state: [], // multi-select
  product_type: [], // multi-select
  // Not a filter: LoanSchedule.vue writes the open loan's LMS status here and
  // Ledger.vue reads it back. It lives in this module only because both sides
  // already had it injected. Declared in LmsList's structuralFilterKeys so the
  // filter-coverage guard doesn't mistake it for an untracked filter.
  loan_status: "",
  dealer_id: [], // multi-select
  company_name: "",
  // Borrower Company: the borrower's employer, typed free-hand
  employer_name: "",
  resync_status: "",
  // Completed tab only: how the loan was closed ("Written-off" / "Settled" /
  // "Foreclose" / "Closed", the backend's values). "" -> every completed loan.
  settlement_status: "",
  // "true" -> only blacklisted customers, "false" -> only everyone else,
  // "" -> no filtering. The backend parses these strings; see lms/api.py.
  blacklisted: "",
  fresh_loan: [], // multi-select (Loan Type: Fresh Loan / Reloan / Reapplied Loan)
  // Payable (staff only): "true" -> loans the partner is paid for, "false" ->
  // the rest, "" -> no filtering. See app-js/payable-filter.js.
  payable_loan_flag: "",
  // Direction of the per-tab date sort (disbursal / completed / NOC-requested
  // date, picked by the backend from the active tab). Newest first by default.
  sort_order: "desc",
});

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    SET_LOAN_STATUS(state, value){
      state.loan_status = value;
    },
    RESET_FILTERS(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    setLoanStatus({commit}, value){
      commit("SET_LOAN_STATUS", value)
    },
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
    getLoanStatus: (state) => {
      return state.loan_status;
    }
  },
};
